/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} These_Seemly_Stork_FulfillInputs */

const fr_these_seemly_stork_fulfill = /** @type {(inputs: These_Seemly_Stork_FulfillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inscrits`)
};

/**

* @param {These_Seemly_Stork_FulfillInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const these_seemly_stork_fulfill = /** @type {((inputs?: These_Seemly_Stork_FulfillInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<These_Seemly_Stork_FulfillInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_these_seemly_stork_fulfill(inputs)
});